import { Col, Row, Typography, Breadcrumb } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import { translate } from "../../../locale";
import SubscriptionsTable from "../../../components/Tables/SubscriptionsTable";

const { Title } = Typography;

const Subscriptions = () => {
  return (
    <div className="flex flex-col min-h-full w-screen max-w-7xl pb-16 m-10">
      <Row gutter={16}>
        <Col className="gutter-row mb-4" span="24">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/admin">Inicio</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Suscripciones</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col span="24" className="my-4">
          <Title level={2} className="text-center">
            {translate("Suscripciones")}
          </Title>
        </Col>
        <Col className="gutter-row mb-6" span="24">
          <SubscriptionsTable />
        </Col>
      </Row>
    </div>
  );
};

export default Subscriptions;
